import { Box } from '@mui/material';
import { AdviseSupplierInvoice } from '../../../../types/advise';
import { TextSpan } from '../../../Atoms/Text';
import { InvoiceStatusPill, needsManualEntry } from './InvoiceStatusPill';
import { CARD_ACTION_LINK, CARD_QUIET_ACTION } from './supplierCardStyles';

export interface SupplierInvoiceRowProps {
  invoice: AdviseSupplierInvoice;
  canEdit: boolean;
  onOpen: () => void;
  onRemove: () => void;
}

/** An uploaded invoice: its status, and View or Enter line items, with Remove for an editor. */
export const SupplierInvoiceRow = ({ invoice, canEdit, onOpen, onRemove }: SupplierInvoiceRowProps) => {
  const pending = needsManualEntry(invoice);
  return (
    <Box className="flex items-center gap-2.5 rounded-md bg-grey-1 px-3 py-2.5">
      <span
        aria-hidden
        className={`h-1.5 w-1.5 shrink-0 rounded-full ${pending ? 'bg-amber-500' : 'bg-green-600'}`}
      />
      <TextSpan
        size="sm"
        color="grey8"
        className="truncate">
        {invoice.file_name}
      </TextSpan>
      <InvoiceStatusPill invoice={invoice} />
      <Box className="flex items-center gap-1.5">
        <button
          type="button"
          className={CARD_ACTION_LINK}
          onClick={onOpen}>
          {canEdit && pending ? 'Enter line items' : 'View'}
        </button>
        {canEdit && (
          <>
            <TextSpan
              size="xs"
              color="grey6">
              ·
            </TextSpan>
            <button
              type="button"
              className={CARD_QUIET_ACTION}
              onClick={onRemove}>
              Remove
            </button>
          </>
        )}
      </Box>
    </Box>
  );
};
